import { render, staticRenderFns } from "./RiskMailboxOffline.vue?vue&type=template&id=647e9eee&scoped=true&"
import script from "./RiskMailboxOffline.vue?vue&type=script&lang=js&"
export * from "./RiskMailboxOffline.vue?vue&type=script&lang=js&"
import style0 from "./RiskMailboxOffline.vue?vue&type=style&index=0&id=647e9eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647e9eee",
  null
  
)

export default component.exports